import * as React from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import {
  CustomTimeRangeCategoriesCollection,
  useFetchTimeSettingsCustomTimeRangeCategories,
} from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

interface TimeSettingsCategoryState {
  timeSettingsCategories: CustomTimeRangeCategoriesCollection
}

const TimeSettingsCategory = React.createContext<TimeSettingsCategoryState | null>(null)

export const useTimeSettingsCategory = () => {
  const context = React.useContext(TimeSettingsCategory)

  if (!context) {
    throw new Error('useTimeSettingsCategory must be used within a TimeSettingsCategory')
  }
  return context
}

export const TimeSettingsCategoryProvider = ({ children }: React.PropsWithChildren) => {
  const {
    company: { id: currentCompanyId },
  } = useCurrentSession()

  const { categories: timeSettingsCategories } =
    useFetchTimeSettingsCustomTimeRangeCategories(currentCompanyId)

  return (
    <TimeSettingsCategory.Provider value={{ timeSettingsCategories }}>
      {children}
    </TimeSettingsCategory.Provider>
  )
}
